const getYolaUrl = (rootState) => rootState.config.common.yolacom.url;

export default getYolaUrl;
